/** Inertia `only` keys to refresh asset list and pagination (e.g. after add, delete, move, upload). */
export const INERTIA_ONLY_ASSETS_AND_PAGINATION: string[] = ['assets', 'pagination'];

/** Inertia `only` keys to refresh assets, folders, and pagination (e.g. after restore folder, empty trash). */
export const INERTIA_ONLY_ASSETS_FOLDERS_AND_PAGINATION: string[] = [
  'assets',
  'folders',
  'pagination',
];
